function MainWeb() {
}

MainWeb.fn = {
    init: function () {
        MainWeb.fn.addRoom.call(this);
        MainWeb.fn.deleteRoom.call(this);
        MainWeb.fn.autoCheckForm.call(this);
        MainWeb.fn.initDatePicker.call(this);
        MainWeb.fn.calculatePriceExtra.call(this);
        MainWeb.fn.collapseExpandInsurance.call(this);
        MainWeb.fn.validateVatNumber.call(this);
        MainWeb.fn.handleExtraUsers.call(this);
        MainWeb.fn.checkCompanyType.call(this);
        // MainWeb.fn.downloadTermsConditions.call(this);
        MainWeb.fn.showConfirmPopupSubmit.call(this);
        MainWeb.fn.showUnsubscribePopupSubmit.call(this);
    },

    addRoom: function() {
        $(document).on("click", ".add-room", function(){
            var lastRow = $(".trip-rooms .row-item").last();
            var lastNumber = lastRow.data("number");
            var newNumber = lastNumber + 1;
            var html = $(".trip-rooms .row-clone").clone();

            // html.find('input[type="number"]').val(0);
            html.find('input[type="radio"]').prop('checked', false);
            html.removeClass('row-clone').attr('data-number', newNumber);
            html.find('.room-number').attr('data-number', newNumber);
            html.find(".room-number").text(parseInt(newNumber) + 1);
            html.find(".delete-room").removeClass('hidden');

            if (html.find(".age-group-value").length) {
                html.find(".age-group-value").map(function () {
                    var id = $(this).data('id');
                    var str = html.find(".age-group-value").attr('name');
                    var res = str.replace(str, "booking["+newNumber+"][age_group]["+id+"]");
                    $(this).val(0).attr("name", res);
                });
            }


            // html.find(".age-group-value").attr("name", "booking["+newNumber+"][age_group]");
            // html.find(".children").attr("name", "booking["+newNumber+"][children]");
            // html.find(".baby").attr("name", "booking["+newNumber+"][baby]");
            html.find(".type").attr("name", "booking["+newNumber+"][room_id]").removeAttr('disabled');
            html.find(".room-price").text("");
            $(".trip-rooms").append(html);
        });
    },

    deleteRoom: function() {
        $(document).on('click', '.delete-room', function(){
            $(this).closest('.row-item').remove();
            $(".auto-check").trigger('change');
        });
    },

    autoCheckForm: function () {
        var autoCheckFormProcess = function (_this) {
            var _this = $(_this);
            var form = _this.closest('form');

            MainWeb.fn.checkBookingForm.call(_this, form);
        };

        $(document).on('keyup', 'input.auto-check', MainWeb.fn.delay(function (event) {
            autoCheckFormProcess(this);
        }, 300));

        $(document).on('change', 'input[type="radio"].auto-check', MainWeb.fn.delay(function (event) {
            autoCheckFormProcess(this);
        }, 300));
    },

    checkBookingForm: function(selfForm) {
        var _this = $(this);
        var url = selfForm.attr('action');
        var method = selfForm.attr('method');
        var submit = selfForm.find('[type="submit"]');
        var formData = new FormData(selfForm[0]);
        $('body').loading('toggle');
        submit.attr('disabled', 'disabled');

        $.ajax({
            url: url,
            type: method,
            data: formData,
            contentType: false,
            cache: false,
            processData: false,
        }).success(function (response) {
            if (response.success == true) {
                $("#total-price").text(response.data.total);
                $("#input-total-price").val(response.data.total);

                $.each(response.data.rooms, function(index, value){
                    $.each(value, function(room_id, value2){
                        if (value2 == false) {
                            $('.trip-rooms .row-item[data-number="'+index+'"]').find('input[data-room-id="'+room_id+'"]').attr('disabled', 'disabled').prop('checked', false);
                        } else {
                            $('.trip-rooms .row-item[data-number="'+index+'"]').find('input[data-room-id="'+room_id+'"]').removeAttr('disabled');
                        }
                    });
                });

                $.each(response.data.prices, function(index, value){
                    $.each(value, function(room_id, value2){
                        if (value2 != 0) {
                            var price = value2 > 0 ? " (+" +value2+ " euro)" : " (" +value2+ " euro)";
                            $('.trip-rooms .row-item[data-number="'+index+'"]').find('span[data-room-id="'+room_id+'"]').text(price);
                        } else {
                            $('.trip-rooms .row-item[data-number="'+index+'"]').find('span[data-room-id="'+room_id+'"]').text("");
                        }
                    });
                });

                if($('.trip-rooms .row-item').length) {
                    var ageId = _this.data('id');
                    var total = 0;
                    $('input[data-id="'+ageId+'"]').map(function () {
                        total = total + parseInt($(this).val());
                    });
                    $("#age_"+ageId).text(total);

                    var data = "";
                    var language = $('.trip-rooms').data('language');
                    $('.trip-rooms .row-item').map(function () {
                        var persons = 0;
                        var number = $(this).data('number');
                        $(this).find('input[type="text"]').map(function () {
                            persons = persons + parseInt($(this).val());
                        });

                        $(this).find('input[type="radio"]').map(function () {
                            if ($(this).is(":checked")) {
                                if (persons > 0) {
                                    var personName = persons > 1 ? language.count_persons : language.count_person;
                                    data += language.room+' '+(parseInt(number) + 1)+": "+$(this).data('name')+", "+persons+" "+personName+"<br>";
                                }
                            }
                        });
                    });
                    $(".show-room").html(data);
                }
            }
        }).always(function () {
            submit.removeAttr('disabled');
            $('body').loading('toggle');
        });
    },

    calculatePriceExtra: function() {
        $(document).on('click', '.checkbox-extra', function () {
            var data = "";
            var totalPrice = 0;

            $('.options .row-item').each(function () {
                var price = 0;
                var peron = 0;
                $(this).find('.list-person').each(function () {
                    if ($(this).find('.checkbox-extra').is(":checked")){
                        price += parseInt($(this).find('.checkbox-extra').val());
                        peron ++;
                    }
                });

                var id = $(this).data('id');
                $('.show-price-'+id).text(price);
                totalPrice += price;

                if (peron > 0) {
                    data += peron +" x "+ $(".service-name-"+id).text()+"<br>";
                }
            });

            $(".show-extra").html(data);
            var endPrice = parseInt(totalPrice) +  parseInt($("#total-price").data('price'));
            $("#total-price").text(endPrice);
            $("#input-total-price").val(endPrice);
        });
    },

    collapseExpandInsurance: function() {
        $(document).on('click', '.panel-heading', function () {
            $(".checkbox-insurance").attr('disabled', 'disabled').prop('checked', false);

            var target = $(this).data('target');
            $(".panel-collapse.collapse.in").removeClass('in');
            $(target).toggleClass('in');

            $(this).find('.column-left .insurance-radio').prop('checked',true);
            var target = $(this).closest('.insurance-default');
            target.find('.panel-collapse .checkbox-insurance').removeAttr('disabled');

            var endPrice = parseFloat($("#total-price").data('price'));
            $("#total-price").text(endPrice);
            $("#input-total-price").val(endPrice);
        });

        $(document).on('click', '.checkbox-insurance', function () {
            var totalPrice = 0;

            $('.step4 .insurance-default').each(function () {
                var price = 0;
                $(this).find('.list-person').each(function () {
                    if ($(this).find('.checkbox-insurance').is(":checked")){
                        price += parseFloat($(this).find('.checkbox-insurance').val());
                    }
                });

                totalPrice += price;
            });

            var endPrice = parseFloat(totalPrice) +  parseFloat($("#total-price").data('price'));
            $("#total-price").text(endPrice);
            $("#input-total-price").val(endPrice);
        });
    },

    validateVatNumber: function() {
        $(document).on('blur', '#vat_number', function () {
            let vat = $(this).val();

            if (!vat.trim()) {
                return;
            }

            vat = vat
                .replace(/^(BE|NL)/i, '')
                .replace(/[\s.-]/g, '');
            let postData = {
                "countryCode": $('#land').val(),
                "vatNumber": vat
            }
            $.ajax({
                type: 'POST',
                url: $(this).attr('data-route'),
                data: postData,
                beforeSend: function () {
                    $('.checking-vat-overlay').show();
                    $('.vat-error').hide();
                    $('.vat-fail-check').hide();
                },
                success: function (data) {
                    if (data.valid) {
                        $('#organization_name').val(data.name);
                        $('#address').val(data.address);
                        $('#postcode').val(data.postcode);
                        $('#place').val(data.place);
                        $('#is_valid_vat').val(1)
                    } else {
                        $('.vat-error').show();
                        $('.vat-error').text(data.error);
                        $('.vat-fail-check').show();
                        $('#is_valid_vat').val(0);
                    }
                },
                complete: function () {
                    $('.checking-vat-overlay').hide();
                }
            })
        });

        $(document).on('change', '#confirm-vat-correct', function () {
           $('.vat-error').toggle(! $(this).is(':checked'));
        });
    },

    handleExtraUsers: function () {
        const PRICE_PER_PERSON = 5.00;
        let personCount = parseInt($('#add-users-form').attr('data-person-count'), 10);
        let personIndex = parseInt($('#add-users-form').attr('data-person-index'), 10);
        let remainingSpots = parseInt($('#add-users-form').attr('data-remaining-spots'), 10);

        function updatePriceSummary() {
            $('#person-number').text(personCount);
            $('.price-total span').text('€' + (personCount * PRICE_PER_PERSON).toFixed(2));
        }

        function relabelPersons() {
            $('#extra-persons .extra-person').each(function (i) {
                $(this).find('.participant-index').text('#' + (i + 1));
            });
        }

        function updateSpotsUI() {
            const reachedLimit = personCount >= remainingSpots;
            $('.btn-add-person').prop('disabled', reachedLimit);
            $('#spots-warning').prop('hidden', !reachedLimit);
        }

        updateSpotsUI();

        $(document).on('click', '#extra-persons .close', function () {
            $(this).closest('.extra-person').remove();
            personCount--;
            $('#spots-number').text(personCount);
            relabelPersons();
            updatePriceSummary();
            updateSpotsUI();
        });

        $(document).on('click', '.btn-add-person', function () {
            if (personCount >= remainingSpots) return;

            personCount++;
            let $block = $('#person-template .extra-person').clone();
            $block.find('.participant-index').text('#' + personCount);
            let updatedHtml = $block.prop('outerHTML').replaceAll('__INDEX__', personIndex);
            $block = $(updatedHtml);
            personIndex++;
            $('#extra-persons').append($block);
            $('#spots-number').text(personCount);
            updatePriceSummary();
            updateSpotsUI();
            $block.find('input').first().focus();
        });
    },

    checkCompanyType: function() {
        $(document).on('click', 'input[name=contact_type]', function () {
            var value = $(this).val();

            if(value == 0) {
                $(".field-company").removeClass('hidden');
                $(".field-personal").addClass('hidden');

                $("#first_name, #last_name").removeAttr('required');
                $("#company_name, #vat_number").attr('required', 'required');
            } else {
                $(".field-company").addClass('hidden');
                $(".field-personal").removeClass('hidden');

                $("#company_name, #vat_number").removeAttr('required');
                $("#first_name, #last_name").attr('required', 'required');
            }
        })
    },

    initDatePicker: function() {
        $('.datepicker').each(function () {
            var txtDate = $(this);

            // Date picker
            var datepickerOptions = {weekStart: 1};

            // Min date
            var attrMinDate = txtDate.data('min-date');

            if (attrMinDate) {
                datepickerOptions['startDate'] = attrMinDate;
            }

            // Max date
            var attrMaxDate = txtDate.data('max-date');

            if (attrMaxDate) {
                datepickerOptions['endDate'] = attrMaxDate;
            }

            // Only show the days
            var attrDaysOfWeekDisabled = txtDate.data('days-of-week-disabled');

            if (attrDaysOfWeekDisabled) {
                datepickerOptions['daysOfWeekDisabled'] = attrDaysOfWeekDisabled;
            }

            // Register date picker
            txtDate.datepicker(datepickerOptions);

            /**
             * @event onChangeInputDisplay
             * @param {jQuery} input
             */
            var onChangeInputDisplay = function (input) {
                var fieldInfo = input.data('info');
                var field = input;
                var container = input.parent();
                // var name = input.attr('name');
                // Split name to array to detect is display field or not
                // var arrName = name.split('_');
                // var isDisplayField = (arrName[arrName.length - 1] === 'display');
                var isDisplayField = typeof fieldInfo !== 'undefined' && typeof fieldInfo.name !== 'undefined';
                var suffix = '';

                if (isDisplayField) {
                    field = container.find('[name="' + fieldInfo.name + '"]');
                    suffix = '_display';

                }
                // var val = input.val();
                var date = input.datepicker('getDate');

                var strDate = (date) ? moment(date).format('YYYY-MM-DD') : '';
                if (isDisplayField && field.length > 0) {
                    field.val(strDate);
                }

                // Set ranger for datepicker ranger
                if (typeof input.data('datepicker-range-min') !== 'undefined') {
                    $('[name="' + input.data('datepicker-range-min') + suffix + '"]').datepicker("setStartDate", date);
                }

                if (typeof input.data('datepicker-range-max') !== 'undefined') {
                    $('[name="' + input.data('datepicker-range-max') + suffix + '"]').datepicker("setEndDate", date);
                }

            };

            /**
             * When change date picker
             * Listen for the change even on the input
             * @link https://stackoverflow.com/a/22507814/10174865
             */
            txtDate.on('changeDate', function (e) {
                var input = $(e.currentTarget);
                // Hide picker
                // input.datepicker('hide');
                // Register on change
                onChangeInputDisplay(input);
            });

            /**
             * When hide date picker
             */
            txtDate.on('hide', function (e) {
                var input = $(e.currentTarget);
                // Register on change
                onChangeInputDisplay(input);
            });

            /**
             * When change date input
             */
            txtDate.on('change', function (e) {
                var input = $(e.currentTarget);
                // Register on change
                onChangeInputDisplay(input);
            });
        });
    },
    // downloadTermsConditions: function () {
    //     $('.terms_and_conditions').on('click', function () {
    //         let route = $(this).data('route');
    //         var generalTermsConditionsWindow = window.open('', '_blank');
    //         $('body').loading('toggle');
    //         $.ajax({
    //             url: route,
    //             type: "GET",
    //             dataType: "JSON",
    //             success: function (response) {
    //                 let documentFiles = response.data.documentFiles
    //                 $.each(documentFiles, function(index, documentFile) {
    //                     generalTermsConditionsWindow.location.href = documentFile;
    //                     return;
    //                 });
    //
    //                 $('body').loading('toggle');
    //             },
    //             error: function (error) {
    //                 console.log(error)
    //             }
    //         })
    //     })
    // },
    delay: function (callback, ms) {
        var timer = 0;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    },

    showConfirmPopupSubmit: function(){
        $(document).on('click', '.show-confirm', function () {
            var _this = $(this);
            var title = _this.data('title');
            var yesLabel = _this.data('yes_label');
            var noLabel = _this.data('no_label');
            var formID = $('#cancel-booking');

            Swal.fire({
                width: 512,
                padding: '35px 30px 30px 30px',
                title: title,
                showDenyButton: false,
                showCancelButton: true,
                focusConfirm: false,
                focusDeny: false,
                showCloseButton: false,
                denyButtonText: yesLabel,
                confirmButtonText: yesLabel,
                cancelButtonText: noLabel,
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    $('#cancel-booking').append('<input type="hidden" name="is_redirect" value="1" />');
                    formID.submit();
                } else if (result.isDenied) {
                    // formID.submit();
                } else if (result.dismiss == 'cancel') {
                    formID.submit();
                }
            });

            return false;
        });
    },

    showUnsubscribePopupSubmit: function(){
        $(document).on('click', '.show-unsub', function () {
            var _this = $(this);
            var title = _this.data('title');
            var yesLabel = _this.data('yes_label');
            var noLabel = _this.data('no_label');
            var formID = _this.data('form_id');
            var form = $('#' + formID);

            var userHasIban = _this.data('user_has_iban');

            if (!userHasIban) {
                $('#ibanModal').modal('show');
                $('#ibanModal').data('form_id', formID);
            } else {
                Swal.fire({
                    icon:'warning',
                    width: 512,
                    padding: '35px 30px 30px 30px',
                    title: title,
                    showDenyButton: false,
                    showCancelButton: true,
                    focusConfirm: false,
                    focusDeny: false,
                    showCloseButton: false,
                    denyButtonText: yesLabel,
                    confirmButtonText: yesLabel,
                    cancelButtonText: noLabel,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        form.append('<input type="hidden" name="is_confirmed" value="1" />');
                        form.submit();
                    } else if (result.isDenied) {
                        // formID.submit();
                    } else if (result.dismiss == 'cancel') {
                        form.append('<input type="hidden" name="is_confirmed" value="0" />');
                        form.submit();
                    }
                });
            }

            return false;
        });

        $('#saveIban').on('click', function () {
            var iban = $('#modal-iban').val();
            var formID = $('#ibanModal').data('form_id');
            var form = $('#' + formID);

            if (iban) {
                form.append(`<input type="hidden" name="iban" value="${iban}" />`);

                $('#ibanModal').modal('hide');

                form.submit();
            }
        });
    },

    rule: function () {
        $(document).ready(function () {
            MainWeb.fn.init.call(this);
        });
    },
};

MainWeb.fn.rule();
